import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Recommendations as SchemaRecommendations } from '../schemas/Recommendations';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetOrderRecommendationsContentType = '' as const;
export type GetOrderRecommendationsRequest = undefined;
export type GetOrderRecommendationsResponses = LinkCommonErrorResponses & {
    /**
     * @description Get recommended product cards and variants for order
     */
    '200': {
        'application/json': SchemaRecommendations;
    };
};
export type GetOrderRecommendationsResponseSuccess = GetOrderRecommendationsResponses['200']['application/json'];
export type GetOrderRecommendationsSearchParams = {
    signature: string;
};
export type GetOrderRecommendationsPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetOrderRecommendationsUrl = '/{store_slug}/recommendations/{order_id}' as const;
export const GetOrderRecommendationsMethod = 'GET' as const;
export const getGetOrderRecommendationsUrl = (params: GetOrderRecommendationsPathParameters) =>
    GetOrderRecommendationsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetOrderRecommendationsPathParameters) =>
        String(params[param])
    );
